<template>
  <el-dialog
    title="从业人员信息"
    :visible.sync="employ_dialogVisible"
    width="70%"
    :before-close="handleClose"
    :close-on-click-modal="true"
  >
    <div>
      <el-form :model="queryParams" ref="queryParamsRef" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="人员姓名" prop="personName">
              <el-input v-model="queryParams.personName" placeholder="请输入人员姓名" clearable />
            </el-form-item>
          </el-col>
          <el-col style="text-align: center;">
            <el-button type="primary" icon="Search" @click="getList">搜索</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column type="index" width="55" label="序号" align="center">
          <template
            slot-scope="scope"
          >{{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="personName" label="人员姓名" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="personType" label="人员类型" align="center" show-overflow-tooltip>
          <!-- <template slot-scope="scope">{{ $common.getTypeText(scope.row.type)}}</template> -->
        </el-table-column>
        <el-table-column prop="contactInfo" label="联系方式" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
  </el-dialog>
</template>
    <script>
import { getAgentpersonList } from "@/api/index";
export default {
  props: {
    employ_dialogVisible: {
      type: Boolean,
      default: false
    },
    unifiedSocialCreditCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      queryParams: {
        pageSize: 10,
        pageNum: 1,
        unifiedSocialCreditCode: "",
        personName: ""
      },
      tableData: [],
      total: 0
    };
  },
  mounted() {
    console.log(this.unifiedSocialCreditCode);

    this.queryParams.unifiedSocialCreditCode = this.unifiedSocialCreditCode;
    this.getList();
  },
  methods: {
    handleClose() {
      this.$emit("update:employ_dialogVisible", false);
    },
    getList() {
      getAgentpersonList({ ...this.queryParams }).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    }
  }
};
</script>
    <style lang="less" scoped>
.main {
  width: 1200px;
  min-height: calc(100vh - 421px);
  margin: 0px auto;
  background-color: #fff;
  margin-top: 20px;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 0px 20px;
}
/deep/ .el-dialog {
    margin-top: 8vh!important;
}
</style>